<template>
	<div class="template-box">
		<div class="page-title">订单详情</div>
		<div class="loading-box" v-if="loading">
			<van-loading size="24px" color="#1989fa">加载中...</van-loading>
		</div>
		<template v-if="!loading">
			<!-- 订单信息 -->
			<div class="card-box">
				<div class="card-title-box">订单信息</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">收费名称</div>
						<div class="card-content-item-left">
							{{ qrCodeDetail.fee_name }}
						</div>
					</div>
				</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">收费金额</div>
						<div class="card-content-item-left">{{ qrCodeDetail.fee_price }} 元</div>
					</div>
				</div>
			</div>
			<!-- 支付明细 -->
			<div class="card-box">
				<div class="card-title-box">支付明细</div>
				<div class="card-content-box">
					<div class="card-content-item-sb">
						<div class="card-content-item-right">总计费用</div>
						<div class="card-content-item-left">￥{{ qrCodeDetail.fee_price }}</div>
					</div>
				</div>
			</div>
			<!-- 支付方式 -->
			<div class="card-box" v-if="qrCodeDetail.order_status == 1">
				<div class="card-title-box">支付方式</div>
				<div class="card-content-box">
					<div class="card-content-item-sb">
						<div class="pay-content-right" v-if="qrCodeDetail.channel === 'wx'"><img src="../../assets/wxpay.png" alt="微信支付" class="wxpay-img" />微信支付</div>
						<div class="pay-content-right" v-else><img src="../../assets/alipay.png" alt="支付宝支付" class="wxpay-img" />支付宝支付</div>
						<div class="card-content-item-left">
							<van-radio-group v-model="radio">
								<van-radio name="1"></van-radio>
							</van-radio-group>
						</div>
					</div>
					<van-button type="info" @click="getToPay">提交并支付</van-button>
				</div>
			</div>
			<div class="card-box" v-if="qrCodeDetail.order_status == 2">
				<div class="card-order">当前订单已完成</div>
			</div>
			<div class="card-box" v-if="qrCodeDetail.order_status == 3">
				<div class="card-order">当前订单已关闭</div>
			</div>
			<div class="pay-text-box"></div>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			radio: '1',
			qrCodeDetail: {},
			loading: false,
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		// 是否在微信
		is_weixn() {
			let ua = window.navigator.userAgent.toLowerCase()
			return ua.match(/MicroMessenger/i) == 'micromessenger'
		},
		// 获取详情信息
		getData() {
			let self = this
			let orderNo = this.$route.query.orderId
			self.loading = true

			self.vaxios.get(`${self.vaxios.host}/open/api/v1/counter/${orderNo}/detail`, { orderNo }, (res) => {
				if (res === -1 || !res.data) {
					self.$toast.fail({ duration: 0, message: '获取信息失败,请重新扫码！' })
					return
				}
				self.qrCodeDetail = res.data
				self.loading = false
			})
		},
		// 调用支付
		getToPay() {
			let self = this
			let order_no = this.$route.query.orderId

			// 微信内
			if (self.is_weixn()) {
				self.$toast('请使用外部浏览器打开订单页面后支付!')
				return
			}

			// 微信外 和 支付宝
			self.vaxios.post(`${self.vaxios.host}/open/v1/payment/toPay`, { order_no }, (res) => {
				if (res === -1 || !res.data) return
				self.qrCodeDetail.channel === 'wx' ? this.outsideWeChatPay(res) : this.aliPay(res)
			})
		},
		// 微信外支付
		outsideWeChatPay(res) {
			window.location.href = res.data
		},
		// 支付宝
		aliPay(res) {
			const div = document.createElement('div')
			div.id = 'alipay'
			div.innerHTML = res.data
			document.body.appendChild(div)
			document.querySelector('#alipay').children[0].submit()
		},
	},
}
</script>

<style scoped lang="scss">
.template-box {
	background: #f7f4f8;
	height: 100%;
}
.page-title {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	background-color: #fff;
	font-weight: 500;
	font-size: 18px;
}
.card-box {
	background-color: #fff;
	margin: 10px;
	padding: 10px 10px 0 10px;
	.card-title-box {
		font-size: 18px;
		font-weight: 500;
		padding-bottom: 10px;
		border-bottom: 1px solid #f4f4f4;
	}
	.card-content-box {
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		.card-content-item {
			display: flex;
			padding-bottom: 10px;
		}
		.card-content-item-sb {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 10px;
		}
		.card-content-item-left {
			font-size: 14px;
		}
		.card-content-item-right {
			color: #999;
			font-size: 14px;
			width: 100px;
			flex-shrink: 0;
		}
	}
	.total-price-box {
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		.total-price-title {
			color: #999;
			font-size: 14px;
			padding-right: 10px;
		}
		.total-price-price {
			font-weight: 600;
			color: #e98c70;
		}
	}
	.pay-content-right {
		display: flex;
		color: #999;
		font-size: 14px;
		align-items: center;
		.wxpay-img {
			width: 35px;
			height: 35px;
		}
	}
	.qrcode-box {
		display: flex;
		align-items: center;
		justify-content: center;
		.qrcode-img {
			width: 200px;
			height: 200px;
		}
	}
}
.pay-text-box {
	margin: 10px;
	padding: 10px 0;
	display: flex;
	flex-direction: column;
	font-size: 14px;
	color: #999;
}
.loading-box {
	display: flex;
	align-items: center;
	justify-content: center;
}
.card-order {
	color: red;
	text-align: center;
	padding-bottom: 10px;
}
</style>
